import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  let requestBody: any = null

  if (import.meta.server) {
    const event = useRequestEvent(useNuxtApp())
    if (event?.context.requestBody) {
      requestBody = JSON.parse(JSON.stringify(event.context.requestBody))
      nuxtApp.payload.requestBody = requestBody
    }
  }

  if (import.meta.client) {
    requestBody = nuxtApp.payload.requestBody
  }

  nuxtApp.provide('requestBody', requestBody)
})
